export function mutateSearchParam(
  key: string,
  value: string | undefined,
  searchParam: URLSearchParams
) {
  if (value) {
    searchParam.set(key, value);
  } else {
    searchParam.delete(key);
  }
}

export function parseToNumber(val: string) {
  return parseInt(val);
}
